import { placesFwkBootPostStartAction } from 'hybridspace-performance-datapoints';
import { bootstrap as appBootstrap } from 'owa-bootstrap/lib/bootstrap';
import { setupErrorHandler } from 'owa-exception-handler-devtools';
import { setModuleStateSafe } from 'places-user-session-stores';

import getBootstrapOptions from './getBootstrapOptions';

import type { SessionData } from 'owa-service/lib/types/SessionData';

/** Bootstrap Microsoft Places in standalone mode */
export default function bootstrap(sessionPromise: Promise<SessionData | undefined>): Promise<void> {
    return appBootstrap(getBootstrapOptions(sessionPromise)).then(() => {
        setupErrorHandler();
        setModuleStateSafe('postBoot');
        placesFwkBootPostStartAction();
    });
}
